// @flow
import IdentifierItem from './identifier-item';
import IdentifierItemEmpty from './identifier-item-empty';

export default IdentifierItem;
export { IdentifierItemEmpty };
